const ENDPOINT = {
  login: '/connect/token',
  getUserDetail: '/api/Account/get-user',
  getCustomers: '/api/Customer/get-customers',
  getUsers: '/api/User/get-users',
  forgotPassword: '/api/Account/forget-password',
  resetPassword: '/api/Account/reset-password',
  changePassword: '/api/Account/change-password',
  siteConfigList: '/api/siteconfig/application-parameter',
  manageSiteConfigList: '/api/siteconfig/manage-application-parameters',

  getCustomer: '/api/Customer/get-customer',
  updateCustomer: '/api/Customer/update-Customer',
  registerCustomer: '/api/Customer/register-Customer',
  getCountries: '/api/Customer/GetCountries',

  getProducts: '/api/return-note/get-products',
  serialNoExist: '/api/return-note/serialno-exist',

  getUser: '/api/User/get-user',
  updateUser: '/api/User/update-User',
  registerUser: '/api/User/register-User',

  // rerurn note
  getReturnNote: '/api/return-note/get-form-data',
  getCustomersByName: '/api/Customer/auto-complete',
  saveReturnNote: '/api/return-note/save-return-note',
  updateReturnNote: '/api/return-note/update-return-note',
  moveReturnNote: '/api/Dashboard/move-returnnote',
  getDashboardData: '/api/Dashboard/get-dashborddata',
  getItemById: '/api/Dashboard/getItemById',
  getReturnNoteById: '/api/return-note/get-return-note',
  updateUserProfile: '/api/UserProfile/update-userprofile',
  updateComment: '/api/return-note/update-comment',
  getCommentById: '/api/return-note/get-comment-by-id',
  deleteComment: '/api/return-note/delete-comment',

  // report url
  getReportsType: '/api/Report/getReportsType',
  getReportsProductsType: '/api/Report/getReportsProductsType',
  getProductReportDetail: '/api/Report/product-report',
  getColumnReportDetail: '/api/Report/getColumnReport',
  getRepairInTimeReportDetail: '/api/Report/repair-report',
  exportReport: '/api/Report/exportreports',
  getPerMonthReport: '/api/Report/per-month-report',
  getPerMonthProducTypeReport: '/api/Report/per-month-productype-report',
  getAverageTimeInstatusDataReport: '/api/Report/average-time-in-status-data'
}

export default ENDPOINT;